export default {
  // 模式
  "common.mode.auto": "Otomatik üretim enerjisi kullanım modu",
  "common.mode.economy": "Ekonomik mod",
  "common.mode.exigency": "Acil durum modu",

  // 设备
  "common.grid": "Elektrik ağı",
  "common.evChargers": "Elektrikli araç şarj cihazları",
  "common.evCharger": "Elektrikli araç şarj cihazı",
  "common.pv": "Güneş enerjisi (PV)",
  "common.inverter": "İnverter",
  "common.pcs": "İnverter + batarya",
  "common.terminal": "Terminal cihazı",
  "common.airc": "Klima cihazı",
  "common.engine": "Motor",
  "common.battery": "Batarya",
  "common.metter": "Elektrik sayaç",
  "common.other": "Diğer",
  "common.power": "Güç",
  "common.powerTotal": "Toplam güç",
  "common.voltage": "Voltaj",
  "common.electricity": "Elektrik enerjisi",
  "common.current": "Akım",
  "common.homeUsage": "Ev toplam yükü",
  "common.battery.power": "Batarya gücü",

  // 数据
  "common.noDataAvailable": "Şu anda veri yok~",
  "common.tips": "İpucu",
  "common.reset": "Sıfırla",
  "common.currencyUnit": "¥",
  "common.submiting": "Gönderiliyor... Lütfen bekleyin...",
  "common.close": "Kapat",
  "common.from": "Kaynak",
  "common.useIn": "Kullanım alanı",
  "common.energyPercent": "Enerji akış oranı",
  "common.dataFlow": "Veri akışı",
  "common.getDataIng": "Veri alınıyor... Lütfen bekleyin...",
  "common.pageLoading": "Sayfa içeriği yükleniyor... Lütfen bekleyin...",
  "common.reseting": "Sayfa içeriği sıfırlanıyor... Lütfen bekleyin...",
  "common.save": "Kaydet",
  "common.onlyNumberTips": "Sadece sayı girebilirsiniz",
  "common.offline": "Çevrimdışı",
  "common.online": "Çevrimiçi",
  "common.fault": "Arıza",
  "common.charge": "Şarj",
  "common.discharge": "Deşarj",
  "common.buy": "Al",
  "common.sell": "Sat",
  "common.loadingInfo": "Yükleniyor... Lütfen bekleyin...",

  // 
  "common.moreFeatures": "Daha fazla özellik",
  "common.confirm": "Onayla",
  "common.saveing": "Kaydediliyor... Lütfen bekleyin...",
  "common.searchPlacholder": "Arama için anahtar kelime girin",
  "common.iSee": "Anladım",
  "common.pageErrorTips1": "Oh, sayfada hata oluştu~",
  "common.pageErrorTips2": "Sayfayı yenilemeyi veya destek ile iletişime geçmeyi deneyin~",
  "common.refresh": "Yenile",
  "common.backToHome": "Ana sayfaya dön",
  "common.checkTips": "Kontrol ediliyor... Lütfen bekleyin...",
  "common.back": "Geri",
  "common.cancel": "İptal",
  "common.optional": "İsteğe bağlı",
  "common.required": "Zorunlu",
  "common.status": "Durum",
  "common.statusNoDelete": "Silinmedi",
  "common.statusDelete": "Silindi",
  "common.submit": "Gönder",
  "common.disable": "Devre dışı",
  "common.enable": "Etkinleştir",
  "common.year": "yıl",
  "common.month": "ay",
  "common.day": "gün",
  "common.version": "Sürüm:",
  "common.backHome": " Ana sayfaya dön",
  "common.backHomeSorry": " Maalesef, sayfa yanlışlıkla kayboldu",
  "common.requestTips1": "Veri işleniyor, lütfen tekrar göndermeyin",
  "common.requestTips2": "Sistem bildirimleri",
  "common.requestTips3": "Oturum durumu sona erdi, lütfen tekrar giriş yapın",
  "common.requestTips4": "Tekrar giriş yap",
  "common.requestTips5": "Geçersiz oturum veya oturum sona erdi, lütfen tekrar giriş yapın.",
  "common.requestTips6": "Sunucu hatası, lütfen daha sonra tekrar deneyin.",
  "common.requestTips7": "Sistem arayüzü isteği süresi doldu",
  "common.requestTips8": "Sistem arayüzü",
  "common.requestTips9": "Hata",
  "common.iknow": "Anladım",
  "common.logoutSuccess": "Başarıyla çıkış yapıldı",
  
  // 了解更多组件
  "common.knowMore.title": "Daha fazla bilgi için Beineng ile iletişime geçin",
  "common.knowMore.email": "İletişim e-postası",
  "common.knowMore.phone": "İletişim telefonu",
  "common.knowMore.wechat": "İletişim WeChat",
  "common.knowMore.website": "Resmi web sitesi adresi",
  "common.knowMore.address": "İletişim adresi",
  "common.knowMore.addressDetail": "Qinghe Caddesi 8, Bina 5, 1205 ve 1301 numara odalar, Huangjingkeng Köyü, Huangjiang İlçesi, Dongguan Şehri, Guangdong Eyaleti",
  
  // 本地连接组件
  "common.localConnection": "Yerel bağlantı",
  "common.operateInApp": "İşlemi uygulamada gerçekleştirin!",
  
  "common.enbleStaus": "Etkinleştirme durumu",
  "common.battery.status": "Şarj ve deşarj yok",

  "account.forgetThePassword": "Parolayı unuttum",
  "account.logInDirectly": "Direkt giriş yap",
  "account.tips1": "Sayfaya yönlendiriliyor... Lütfen bekleyin...",
  "account.tips2": "Öncelikle kullanım koşullarını okuyun ve kabul edin!",
  "account.autoLogin": "Otomatik giriş",
  "account.userLogin": "Kullanıcı giriş",
  "account.registerTips": "Henüz hesabınız yok mu? Kayıt olmak için buraya tıklayın",
  "account.userEmail": "Kullanıcı adı / e-posta",
  "account.userEmailTips": "Kullanıcı adı veya e-posta girin",
  "account.password": "Parola",
  "account.passwordTips": "Parola girin",
  "account.submit": "Gönder",
  "account.submitTips": "Gönderiliyor... Lütfen bekleyin...",
  "account.otherLoginTips": "Veya başka bir giriş yöntemi seçin",
  "account.userRegistration": "Kullanıcı kaydı",
  "account.userName": "Kullanıcı adı",
  "account.userNameTips": "Kullanıcı adı girin",
  "account.emailTips1": "E-posta adresi girin",
  "account.emailTips2": "Geçersiz e-posta formatı",
  "account.phone": "Telefon numarası",
  "account.phoneTips1": "Telefon numarası girin",
  "account.phoneTips2": "Geçersiz telefon numarası",
  "account.phoneTips3": "Telefon numarası girin",
  "account.passwordTips1": "Parola girin (6-30 karakter)",
  "account.passwordTips2": "Geçersiz parola formatı: parola, 6-12 karakter uzunluğunda, İngilizce harfler, rakamlar, alt çizgiler, tireler ve noktalardan oluşmalıdır",
  "account.passwordTips3": "Girilen iki parola eşleşmiyor, lütfen kontrol edin ve tekrar girin!",
  "account.passwordTips4": "Parola girin: parola, İngilizce harfler, rakamlar, alt çizgiler, tireler ve noktalardan oluşmalıdır",
  "account.passwordTips5": "Parola onayı",
  "account.passwordTips6": "Parola onayı girin",
  "account.passwordTips7": "Girilen iki parola eşleşmiyor, lütfen kontrol edin ve tekrar girin!",
  "account.passwordTips8": "Parola onayı girin",
  "account.passwordTips9": "Tebrikler, kayıt başarılı!",
  "account.passwordTips10": "Kullanıcı adınız:",
  "account.emailIs": "E-posta:",
  "account.goToLoginPage": "s saniye sonra otomatik olarak giriş sayfasına yönlendirileceksiniz",
  "account.goLogin": "Giriş yap",
  "account.goRegister": "Kayıt ol",
  "account.loginSuccess": "Başarıyla giriş yapıldı",
  "account.email": "E-posta",
  "account.sologn": "Dikkatlice size özelleştirilmiş bir enerji planı oluşturuyoruz",
  "account.pleaseAgree": "Kullanım koşullarını okudum ve kabul ediyorum",
  "userAgreement.privacyPolicy": "gizlilik politikası",

  "account.code": "Doğrulama kodu",
  "account.codeTips": "Doğrulama kodunu girin",
  "account.codeTips2": "Geçersiz doğrulama kodu",

    "account.inviteCodeTips": "Lütfen davet kodunu girin",
    "account.inviteCodeHint": "Davet kodunu almak için lütfen kurulumcu veya işletme ve bakım personeliyle iletişime geçin",
  "account.modifyPasswordByAccount": "Hesap üzerinden parola değiştir",
  "account.modifyPasswordByEmail": "E-posta üzerinden parola değiştir",
  "account.getPasswordByAccount": "Hesap üzerinden parola kurtar",
  "account.getPasswordByEmail": "E-posta üzerinden parola kurtar",

  "account.sendEmailTips": "Doğrulama kodu e-posta adresinize gönderildi, lütfen kontrol edin",
  "account.name": "Hesap adı",
  "account.newPassword": "Yeni parola",
  "account.confirmNewPassword": "Yeni parola onayı",
  "account.nameTips": "Hesap adı girin",
  "account.passwordModifySuccess": "Parola başarıyla değiştirildi",
  "account.emailCode": "E-posta doğrulama kodu",
  "account.emailCodeTips": "E-posta doğrulama kodunu girin",
  "account.emailCodeTips2": "Geçersiz e-posta doğrulama kodu",
  "account.emailModifySuccess": "Parola başarıyla değiştirildi",
  "account.passworTips1": "Parolanız başarıyla sıfırlandı!",
  "account.passwordTips11": "Parola onayı girin",
  "account.passwordTips12": "Yeni parola girin",
  "account.nickname": "Kullanıcı takma adı",
  "account.modifyNickname": "Kullanıcı takma adını değiştir",
  "account.modifyNicknameSuccess": "Kullanıcı takma adı başarıyla değiştirildi!",
  "account.nicknameTips": "Kullanıcı takma adı girin",
  "account.nicknameError": "Kullanıcı takma adı değiştirilemedi!",

  "account.login": "Giriş yap",
  "account.quickRegister": "Hızlı kayıt",
  "account.sendCode": "Invio codice",
  "account.sendTips": "s saniye sonra tekrar gönderebilirsiniz",
  "account.sendEmailIng": "E-posta gönderiliyor... Lütfen bekleyin...",
  "account.emailNotEmpty": "E-posta adresi boş bırakılamaz",
  "account.registerAccount": "Hesap kaydı",
  "account.registerWelcome": "SusprSafe kayıt sayfasına hoş geldiniz",
  "account.usernameLimit": "Kullanıcı adı harfle başlamalı ve sadece harfler, rakamlar ve alt çizgiler içerebilir, uzunluk 5-15 karakter",

  "copyright.desc2": "Web sitesi kayıt bilgisi: Guangdong ICP kaydı 2021169764",

  "editUserInfo.editUserInformation": "Kullanıcı bilgilerini düzenle",
  "editUserInfo.modifyUsername": "Kullanıcı adını değiştir",
  "editUserInfo.changePictures": "Profil fotoğrafını değiştir",
  "editUserInfo.savePicturesSuccess": "Kullanıcı profil fotoğrafı başarıyla kaydedildi",
  "editUserInfo.saveError": "Kaydetme başarısız",
  "editUserInfo.pictureLimit": "Fotoğraf boyutu 2 MB'dan küçük olmalıdır",
  "editUserInfo.uploadPicture": "Profil fotoğrafını yükle",
  "editUserInfo.picturePreview": "Önizleme",
  
  "editUserInfo.bindPhoneNumber": "Telefon numarası bağla",
  "editUserInfo.bindEmail": "E-posta bağla",
  "editUserInfo.changePassword": "Parola değiştir",

  "editUserInfo.notificationSettings": "Bildirim ayarları",
  "editUserInfo.editAccount": "Kullanıcı hesabı bilgilerini düzenle",
  "editUserInfo.waitBingting": "Bağlanıyor... Lütfen bekleyin...",
  "editUserInfo.collapse": "Daralt",
  "editUserInfo.modifyBinding": "Bağlantıyı değiştir",
  
  "editUserInfo.emailAddress": "E-posta adresi",
  "editUserInfo.tips1": "E-posta başarıyla bağlandı",
  "editUserInfo.tips2": "Kaydetme başarısız",
  "editUserInfo.tips3": "E-posta doğrulama kodu gönderiliyor... Lütfen bekleyin...",
  "editUserInfo.tips4": "Doğrulama kodu xxxx e-posta adresine gönderildi, lütfen kontrol edin",
  "editUserInfo.tips5": "Doğrulama kodu gönderimi başarısız!",
  "editUserInfo.tips6": "Telefon numarası zaten bağlanmış",
  "editUserInfo.tips7": "E-posta zaten bağlanmış",
  "editUserInfo.emailTips1": "E-posta adresi girin",
  "editUserInfo.emailTips2": "Geçersiz e-posta formatı",
  "editUserInfo.emailTips3": "xxxx saniye sonra tekrar gönderebilirsiniz",
  "editUserInfo.emailTips4": "Invio codice",
  "editUserInfo.emailTips5": "E-posta doğrulama kodu boş bırakılamaz",
  "editUserInfo.emailTips6": "Geçersiz e-posta doğrulama kodu",
  "editUserInfo.emailCode": "E-posta doğrulama kodu",
  "editUserInfo.save": "Kaydet",

  "editUserInfo.phoneTips1": "Telefon numarası başarıyla bağlandı",
  "editUserInfo.phoneTips2": "SMS doğrulama kodu gönderiliyor... Lütfen bekleyin...",
  "editUserInfo.phoneTips3": "SMS doğrulama kodu xxxx telefon numarasına gönderildi, lütfen kontrol edin",
  "editUserInfo.phoneTips4": "SMS doğrulama kodu gönderimi başarısız!",
  "editUserInfo.phoneTips5": "Telefon numarası girin",
  "editUserInfo.phoneTips6": "Geçersiz telefon numarası formatı",
  "editUserInfo.phoneTips7": "SMS Invio codice",
  "editUserInfo.phoneTips8": "SMS doğrulama kodu",
  "editUserInfo.phoneTips9": "SMS doğrulama kodu boş bırakılamaz",
  "editUserInfo.phoneTips10": "Geçersiz SMS doğrulama kodu",
  "editUserInfo.phone": "Telefon numarası",


  "editUserInfo.noticeTips1": "Bildirim ayarları alınamadı!",
  "editUserInfo.noticeTips2": "Bildirim ayarları başarıyla kaydedildi!",
  "editUserInfo.noticeTips3": "Düşük batarya seviyesi bildirimi",
  "editUserInfo.noticeTips4": "Şarj cihazı şarjı tamamlandı bildirimi",
  "editUserInfo.errorNotification": "Hata bildirimi",
  "editUserInfo.updateNotification": "Güncelleme bildirimi",
  "editUserInfo.monthlyStatisticsNotification": "Aylık istatistikler bildirimi",
  "editUserInfo.notificationMethod": "Alma şekli",

  "editUserInfo.userNameTips1": "Kullanıcı adı başarıyla kaydedildi",
  "editUserInfo.userNameTips2": "Kullanıcı adı kaydedilemedi",
  "editUserInfo.userNameTips3": "Kullanıcı adı girin",
  "editUserInfo.userNameTips4": "Geçersiz kullanıcı adı formatı: sadece rakamlar, alt çizgiler ve İngilizce harfler içerebilir",
  "editUserInfo.userNameTips5": "Kullanıcı adı girin",
  "editUserInfo.userNameTips6": "Kaydediliyor... Lütfen bekleyin...",
  "editUserInfo.userName": "Kullanıcı adı",

  "editUserInfo.avatorTips": "Profil fotoğrafını değiştirmek için tıklayın",
  "editUserInfo.verifyCodeTips1": "Alınan doğrulama kodunu girin:",
  "editUserInfo.verifyCodeTips2": "Hesabınızın güvenliği için aşağıdaki düğmeye tıklayarak orijinal telefon numarasına doğrulama kodu gönderin:",
  "editUserInfo.verifyCodeTips3": "Invio codice",
  "editUserInfo.verifyCodeTips4": "Orijinal telefon numarası doğrulama başarılı, yeni bağlı telefon numarasını girin",
  "editUserInfo.verifyCodeTips5": "Hesabınızın güvenliği için aşağıdaki düğmeye tıklayarak orijinal e-posta adresine doğrulama kodu gönderin:",
  "editUserInfo.verifyCodeTips6": "Orijinal e-posta doğrulama başarılı, yeni e-posta adresini girin",
  "editUserInfo.verifyCodeTips7": "Eski parola",
  "editUserInfo.verifyCodeTips8": "Öncelikle e-posta adresini bağlayın!",
  "editUserInfo.verifyCodeTips9": "Doğrulama kodu e-posta adresine gönderildi, lütfen kontrol edin",
  "editUserInfo.verifyCodeTips10": ", otomatik olarak giriş sayfasına yönlendirileceksiniz",

  "hems.notice.title": "Bildirim başlığı", 
  "hems.notice.content": "Bildirim içeriği", 
  "hems.notice.operate": "İşlem",
  "hems.notice.noRead": "Okunmamış",
  "hems.notice.read": "Okundu",
  "hems.notice.warning": "Uyarı",
  "hems.notice.error": "Hata",
  "hems.notice.success": "İstatistik hesaplama",
  "hems.notice.sys": "Sistem bilgisi",
  "hems.notice.operateSuccess": "İşlem başarılı",
  "hems.notice.operateTips": "İşlem için öğe seçin",

  // 首页
  "hems.home.selfuseRate": "Kendi kullanım oranı",
  "hems.home.percent": "Yüzde",
  "hems.home.todayData": "Bugünlük veriler",
  "hems.home.todayPowerGeneration": "Bugünlük enerji üretimi",
  "hems.home.salesIncome": "Enerji satış geliri",
  "hems.home.saved": "Tasarruf ettiniz",
  "hems.home.reduce": "Karbon ayak izini azaltın",
  "hems.home.tips1": "Şu anda veri yok, henüz xxxx'i bağlamadınız",
  "hems.home.criticalLoad": "Kritik yük",
  "hems.home.keyVoltage": "Kritik voltaj",
  "hems.home.householdLoad": "Ev yükü",
  "hems.home.householdVoltage": "Ev voltajı",
  "hems.home.generalLoad": "Genel yük",
  "hems.home.generalVoltage": "Genel voltaj",
  "hems.home.batteryHealth": "Batarya sağlık durumu",
  "hems.home.averageTemp": "Ortalama sıcaklık",
  "hems.home.gridLoad": "Elektrik ağı yükü",
  "hems.home.toggeleDataSource": "Şu anda görüntülenen veriler şuna değiştirildi:",
  "hems.home.toggleTips": "Değiştirmek istediğinizden emin misiniz?",
  "hems.home.modeSending": "Mod komutu gönderiliyor... Lütfen bekleyin...",
  "hems.home.modeSuccess": "Mod değiştirme komutu başarıyla gönderildi!",
  "hems.home.isOnline": "Çevrimiçi mi?",
  "hems.home.useStatus": "Kullanım durumu",
  "hems.home.workModeText": "Mevcut çalışma modu:",
  "hems.home.toggleDataSourceText": "Şu anda görüntülenen veriler şuna değiştirildi:",
  "hems.ev.charge.status": "Şarj durumu",
  "hems.ev.charge.time": "Şarj süresi",
  "hems.ev.charge.count": "Gerçek şarj miktarı",
  "hems.ev.charge.status.empty": "Boş",
  "hems.ev.charge.status.ing": "Bağlı kablo ile şarj ediliyor",
  "hems.ev.charge.status.null": "Kablo bağlı ancak şarj yapılmıyor",
  "hems.ev.charge.status.error": "Hata",
  "hems.hour": "saat",
  "hems.minue": "dakika",
  "hems.ev.chagre.number": "Şarj cihazı numarası",

  // User Guide
  "hems.userGuide.selfUse": "Üretilen enerjinin kendi kullanımı",
  "hems.userGuide.selfUseTips": "Öncelikle güneş enerjisini kullanın, yeterli değilse elektrik ağından tamamlayın",
  "hems.userGuide.economyMode": "Ekonomik mod",
  "hems.userGuide.economyModeTips": "Elektrik enerjisi fiyatına göre enerji kullanım stratejisini optimize et",
  "hems.userGuide.emergencyMode": "Acil durum modu",
  "hems.userGuide.emergencyModeTips": "Öncelikle kritik yük için enerji sağlanmasını sağlayın",

  // 图表页面
  "hems.history.energyStatistics": "Enerji istatistiği",
  "hems.history.revenueStatistics": "Gelir istatistiği",
  "hems.history.greenStatistics": "Yeşil emisyon azaltımı",
  "hems.history.revenueTitle": "Toplam enerji satış geliri",
  "hems.history.savingsTitle": "Toplam tasarruf",
  "hems.history.carbonTitle": "Toplam karbon azaltımı",
  "hems.history.day": "gün",
  "hems.history.month": "ay",
  "hems.history.year": "yıl",
  "hems.history.beforeDay": "Önceki gün",
  "hems.history.afterDay": "Sonraki gün",
  "hems.history.beforeMonth": "Önceki ay",
  "hems.history.afterMonth": "Sonraki ay",
  "hems.history.beforeYear": "Önceki yıl",
  "hems.history.afterYear": "Sonraki yıl",
  "hems.history.totalUse": "Toplam kullanım",
  "hems.history.fullScreen": "Tam ekran",
  "hems.history.timeSelect": "Tarih seç",
  "sync.tips1": "Veri senkronizasyon komutu başarıyla gönderildi!",
  "sync.tips2": "Veri senkronizasyonu devam ediyor, büyük veri hacmi nedeniyle zaman gerekiyor, yarım saat sonra tekrar kontrol edin~",
  "sync.tips3": "Cihaz veri senkronizasyonunda gecikme olabilir, verilerde tutarsızlık görürseniz tıklayın:",
  "sync.tips4": "Verileri senkronize et",

  "charge.info": "Şarj cihazı bilgileri",
  "news.loading": "Yükleniyor...",
  "news.noMore": "Daha fazla veri yok",
  "hems.pv.power": "Güneş enerjisi miktarı",

  // UEH specific
  "ueh.sellPower": "Satılan enerji miktarı",
  
  "menu.home": "Ana sayfa",
  "menu.history": "Tarihsel veriler",
  "menu.device": "Cihazlar",
  "menu.settings": "Ayarlar",
  "menu.messageCenter": "Mesaj merkezi",
  "menu.help": "Yardım ve destek",
  "menu.mine": "Benim",


  "mine.userSetting": "Kullanıcı ayarları",
  "mine.terminalSetting": "Terminal temel ayarları",
  "mine.uploadCloud": "Verileri buluta yükle",
  "mine.changeVersion": "Güncelleme kontrolü",
  "mine.language": "Dili değiştir",
  "mine.about": "Uygulama hakkında",
  "mine.feedback": "Geri bildirim",
  "mine.logout": "Çıkış yap",
  "mine.logoutAccount": "Hesabı sil",

  "mine.logoutAccountTips": "[] adında hesap siliniyor",
  "mine.logoutAccountTips1": "[] ile bağlı hesap siliniyor",
  "mine.logoutAccountCare": "Hesap silme isteği hakkında notlar:",
  "mine.logoutAccountCare1": "1. Hesap güvenli durumdadır",
  "mine.logoutAccountCare1-1": "Hesap normal kullanım durumundadır, çalınma, kural ihlali veya engelleme riski yoktur.",
  "mine.logoutAccountCare2": "2. Hesap yetkilendirmeleri ve bağlantıları kaldırıldı",
  "mine.logoutAccountCare2-1": "Diğer üçüncü taraflarla olan tüm hesap yetkilendirmeleri kaldırıldı.",
  "mine.logoutAccountCare3": "3. Hesap silindikten sonra geri alınamaz, kullanıcı verileri silinecektir",
  "mine.logoutAccountCare3-1": "Hesap silindikten sonra bağlı telefon numaraları, e-postalar ve diğer veriler silinecek ve geri alınamaz.",
  "mine.confirmLogout": "Silmeyi onayla",
  "mine.logoutSuccess": "Hesap başarıyla silindi!",


  "mine.feedbackIssues": "Sorunlar hakkında geri bildirim",
  "mine.feedQuantity": "Miktar",
  "mine.feedAmount": "Maksimum 9 fotoğraf, her fotoğraf için maksimum boyut 1 MB",

  "mine.notice.fail": "Bildirim ayarları alınamadı!",
  "mine.notice.saveSuccess": "Bildirim ayarları başarıyla kaydedildi!",
  "mine.notice.saveFail": "Kaydetme başarısız!",
  "mine.notice.title": "Bildirim ayarları",
  "mine.notice.batteryLow": "Düşük batarya seviyesi bildirimi",
  "mine.notice.chargingFinish": "Şarj cihazı şarjı tamamlandı bildirimi",
  "mine.notice.error": "Hata bildirimi",
  "mine.notice.update": "Güncelleme bildirimi",
  "mine.notice.monthly": "Aylık istatistikler bildirimi",
  "mine.notice.receiveType": "Alma şekli",

  "mine.language.welcome": "SusprSafe'e hoş geldiniz",
  "mine.language.desc1": "Yaşadığınız yere göre dil sürümünü seçin",
  "mine.language.desc2": "Uygulama ayarlarından herhangi bir zamanda değiştirebilirsiniz",

  "mine.userInfo.avatar": "Profil fotoğrafı",
  "mine.userInfo.nickname": "Takma ad",
  "mine.userInfo.password": "Parola",
  "mine.userInfo.changePassword": "Parola değiştir",
  "mine.userInfo.setPassword": "Parola ayarla",
  "mine.userInfo.phoneNumber": "Telefon numarası",
  "mine.userInfo.bindPhone": "Telefon numarası bağla",
  "mine.userInfo.bindEmail": "E-posta bağla",
  "mine.loginExpired": "Oturum durumu sona erdi, lütfen tekrar giriş yapın",
  "mine.userInfo.title": "Kullanıcı bilgileri",
  "mine.userInfo.bind": "Bağla",
  "mine.userInfo.modify": "Düzenle",
  "mine.userInfo.modifyNickname": "Takma adı değiştir",
  "mine.userInfo.userNickname": "Kullanıcı takma adı",
  "mine.userInfo.selectPic": "Yüklemek için fotoğraf seçin",
  "mine.userInfo.saveSuccess": "Başarıyla kaydedildi",
  "mine.userInfo.uploadFail": "Yükleme başarısız",
  "mine.userInfo.avatarSaveSuccess": "Profil fotoğrafı başarıyla kaydedildi",
  "mine.userInfo.nameTips1": "Kullanıcı takma adı boş bırakılamaz",
  "mine.userInfo.nameTips2": "Kullanıcı takma adı girin",

  "common.pleaseSelect": "Lütfen seçin",
  "question.commonQuestions": "Sık sorulan sorular",
  "account.toggleLanguage": "Dili değiştir",
  "account.localConnection": "Yerel bağlantı",
  "account.selectLanguage": "Lütfen dil seçin",
  "account.sendEmailToast": "Doğrulama kodu xxx e-posta adresine gönderildi, lütfen kontrol edin",
  "account.emailError": "Geçersiz e-posta formatı",
  "account.sendEmailFail": "Gönderim başarısız, lütfen tekrar deneyin",
  
  "common.submitting": "Gönderiliyor... Lütfen bekleyin...",

  "device.page.noData": "Şu anda veri yok, bu sayfa sadece uygulamada görüntülenebilir"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};